import Contact from "../../../Models/CommonProps/Contact";
import mapContactToEntries from "./mapContactToEntries";

export default (contact: Contact) => {
  return mapContactToEntries({ ...contact, name: "" });
};
